import { useEffect, useRef } from "react";
import restartRecommendationRows from "./restartRecommendationRows";
/**
 * Reloads recommendation rows when the viewer id changes, including when an
 * empty id becomes known. A cleared id starts a bounded wait; if that wait
 * times out its listener is gone, so the later id has to restart the row.
 * A wake-up alone would leave the empty result in place.
 */
export default function useRecommendationIdentity({ recommendationUserId, listeners, blocks, applicationId, eligibilityByBlockKey, scheduler, setRowStates, }) {
    const refSeenRecommendationUserId = useRef(recommendationUserId);
    useEffect(() => {
        const seenUserId = refSeenRecommendationUserId.current;
        const hasViewerIdChanged = seenUserId !== recommendationUserId;
        if (hasViewerIdChanged && (seenUserId.length > 0 || recommendationUserId.length > 0)) {
            restartRecommendationRows({
                blocks: blocks.current,
                applicationId,
                scheduler,
                eligibilityByBlockKey: eligibilityByBlockKey.current,
                setRowStates,
            });
        }
        listeners.current.forEach((notifyRecommendationChange) => {
            notifyRecommendationChange();
        });
        refSeenRecommendationUserId.current = recommendationUserId;
    }, [recommendationUserId, listeners, blocks, applicationId, eligibilityByBlockKey, scheduler, setRowStates]);
}
